import {put, takeLatest, call} from 'redux-saga/effects';
import * as optionService from "../../../../services/optionService";
import {
    DELETE_OPTION,
    DELETE_OPTION_SUCCESS,
    DELETE_OPTION_ERROR
}
    from "../../../actions/menu/options";

function* deleteOptionSaga(action) {
    try {
        yield call(optionService.DeleteOption, action.payload)
        yield put({
            type: DELETE_OPTION_SUCCESS,
            payload: action.payload._id
        });

    } catch (error) {
        yield put({
            type: DELETE_OPTION_ERROR,error: error.data
        });
    }
}


export function* deleteOptionSagaWatcher() {
    yield takeLatest(DELETE_OPTION, deleteOptionSaga);
}